module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_salon_sp-30298760ccfa06ea8151d04790cb90c8.svg";